export enum NotAuthorizedReason {
  NOT_ADMIN = 'not-admin',
}
